export const BREAKPOINTS = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
} as const;

export type BreakpointKey = keyof typeof BREAKPOINTS;

// helper function to generate down values
export const getBreakpointDown = (breakpoint: BreakpointKey): number => BREAKPOINTS[breakpoint] - 1;

// Media Queries
export const mediaQueries = {
    // max width
    down: {
        sm: `${getBreakpointDown('sm')}px`,
        md: `${getBreakpointDown('md')}px`,
        lg: `${getBreakpointDown('lg')}px`,
        xl: `${getBreakpointDown('xl')}px`
    },
    // min width
    up: {
        sm: `${BREAKPOINTS.sm}px`,
        md: `${BREAKPOINTS.md}px`,
        lg: `${BREAKPOINTS.lg}px`,
        xl: `${BREAKPOINTS.xl}px`
    }
} as const;

//Example usage:
// import { mediaQueries } from 'hooks/useBreakpoints';
// const isMobile = useMediaQuery(mediaQueries.down.sm);
// const isDesktop = useMediaQuery(mediaQueries.up.lg);
